import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerRightDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerRightDown"><Path d="M4.5 3.5H15V20" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 16L15 20.5L19.5 16" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowCornerRightDown;
